import React from 'react';
import './Chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';
import Quotes from '../Quotes/Quotes';

function Sidebar({ width }) {
  const hyperlinkData = [
    { href: 'https://clinicaltrials.gov/ct2/show/NCT04696731', copy: 'ClinicalTrials.gov' }
  ];
  return (
    <section className="sidebar">
      <h4 className="sidebar__title">
        Exploring the Potential of <span className="nowrap">CAR T</span> in Hard-to-Treat Solid
        Tumors
      </h4>

      <p className="sidebar__copy">
        Although autologous CAR T therapy has been effective in treating blood cancers, their
        success treating solid tumors like kidney, lung, or brain cancers has largely eluded
        researchers. Unlike blood cancers that can be more easily found in the bloodstream, the
        proteins found on the surface of many solid tumors often look too similar to other types of
        cells—essentially hiding them from the body’s immune system.
      </p>
      <p className="sidebar__copy">
        “I think finding that Achilles heel in solid tumors has been more challenging,” says Dr.
        Sumanta (“Monty”) Pal, a recognized leader in solid tumors such as kidney, bladder, and
        prostate cancer, and Co-Director of the Kidney Cancer Program at City of Hope in Los
        Angeles. “It’s critical that we approach these cancers in a way that uniquely targets each
        tumor’s biological make up. There are a number of unique targets that we can exploit.”
      </p>
      <Quotes index={3} origin="sidebar" />
      <p className="sidebar__copy">
        Tackling this issue has been daunting for researchers but new early clinical data showcased
        in late 2022 point to the potential of allogeneic CAR Ts for treating patients suffering
        from advanced or metastatic kidney cancer (referred to as clear cell renal cell carcinoma,
        or RCC) that no longer responds to standard therapies. RCC is the most common type of kidney
        cancer, accounting for approximately 85% of kidney cancer diagnoses; of these about 70% are
        clear cell.<sup>1</sup>
      </p>
      <p className="sidebar__copy">
        Findings from the ongoing Phase 1 TRAVERSE study showed that in advanced or metastatic RCC
        patients whose tumor expressed the CD70 antigen, a one-time infusion of an allogeneic CAR T
        product, designed to target the CD70 antigen had a generally manageable safety profile and
        resulted in a 100% disease control rate (DCR). This means the disease had a best response of
        stable disease or a partial response. 33% of these patients experienced a partial response
        or greater than 30% reduction in the size of cancer tumors.
      </p>
      <p className="sidebar__copy sidebar__cta">
        Researchers continue to enroll patients in the TRAVERSE study.
        {width > 1023 ? <br /> : ' '}
        To learn more about the study or research site, please visit{' '}
        <Hyperlink hyperlinkData={hyperlinkData[0]} origin="sidebar" />.
      </p>
      <p className="sidebar__footnotes">
        <span className="sidebar__footnotes--sup">1.</span>
        <a
          href="https://www.cancer.net/cancer-types/kidney-cancer/introduction"
          target="_blank"
          rel="noreferrer"
          className="sidebar__footnotes--link"
        >
          https://www.cancer.net/cancer-types/kidney-cancer/introduction
        </a>
      </p>
    </section>
  );
}

export default Sidebar;
